import useSWR from 'swr';
import type { AxiosError } from 'axios';
import axios from 'axios';
import type ILabelEnumPair from '../../components/global/GlobalInterfaces';

const GetWorkViewSetDisplayStyles = () :
{
  displayStyles: ILabelEnumPair[] | undefined,
  isLoading: boolean,
  isError: boolean, } => {
  const fetcher = (url: string) => axios.get<ILabelEnumPair[]>(url)
    .then((response) => response.data);

  const { data, error } = useSWR<ILabelEnumPair[], AxiosError>('/workView/GetWorkViewSetDisplayStyles',
    (url) => fetcher(url));

  return {
    displayStyles: data,
    isLoading: !error && !data,
    isError: Boolean(error),
  };
};

export default GetWorkViewSetDisplayStyles;
